'use client';
import { useCallback, useRef } from 'react';
/**
 * Manages user-takeover listeners for this hook instance. Subscriptions persist
 * across renders until the subscriber unsubscribes.
 *
 * @returns Stable functions to send notifications and manage subscriptions.
 */
export function useUserTakeover() {
    const listenersRef = useRef(new Set());
    const subscribeUserTakeover = useCallback((listener) => {
        listenersRef.current.add(listener);
        return () => {
            listenersRef.current.delete(listener);
        };
    }, []);
    const emitUserTakeover = useCallback((reason) => {
        for (const listener of listenersRef.current) {
            listener(reason);
        }
    }, []);
    return { emitUserTakeover, subscribeUserTakeover };
}
//# sourceMappingURL=useUserTakeover.js.map